var map = {
	"./adaptive-icon.png": 3090,
	"./bed.png": 5549,
	"./breastfeeding.png": 8493,
	"./cancel.png": 918,
	"./checked.png": 2339,
	"./close.png": 3464,
	"./complete.png": 1500,
	"./favicon.png": 2663,
	"./food.png": 5020,
	"./globe.png": 9642,
	"./header.png": 6134,
	"./icon.png": 7270,
	"./in.png": 531,
	"./logo-old.png": 215,
	"./logo.png": 6794,
	"./med.png": 1078,
	"./misc.png": 5137,
	"./out.png": 4506,
	"./pain.png": 4902,
	"./phone.png": 4877,
	"./shower.png": 4994,
	"./sick.png": 172,
	"./splash.png": 6958,
	"./toilet.png": 6529,
	"./user.png": 1454,
	"./washroom.png": 9697,
	"./water.png": 3023,
	"./watercup.png": 7046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7075;